import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { ThemeProvider } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import { EmbersCheckbox } from '../../../checkbox/checkbox';
import { EmbersTableCell } from './tableCell/tableCell';
import { embersTableBodyTheme } from './tableBodyStyles';
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  } else return 0;
}
var EMBERS_TABLE_CELL_CLASS = 'EmbersTableCell-root';
var EMBERS_CHECKBOX_CLASS = 'PrivateSwitchBase-input';
export function EmbersTableBody(props) {
  var rows = props.rows,
    order = props.order,
    orderBy = props.orderBy,
    selected = props.selected,
    setSelected = props.setSelected,
    identifier = props.identifier,
    headCells = props.headCells,
    eyeColumn = props.eyeColumn,
    dataMapping = props.dataMapping,
    mappedKeys = props.mappedKeys,
    onRowClick = props.onRowClick,
    isDataSorted = props.isDataSorted,
    getRowCheckboxDisabled = props.getRowCheckboxDisabled,
    getRowDisabled = props.getRowDisabled,
    rowDisabledClassName = props.rowDisabledClassName,
    getExtraRowClasses = props.getExtraRowClasses,
    bodyCheckboxesLabels = props.bodyCheckboxesLabels,
    id = props.id;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipHoverRowIndex = _useState2[0],
    setTooltipHoverRowIndex = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedRowIndex = _useState4[0],
    setFocusedRowIndex = _useState4[1];

  // remove focus on table row if click other blank areas
  useEffect(function () {
    var handleClick = function handleClick() {
      var activeElement = document.activeElement;
      if (!(activeElement !== null && activeElement !== void 0 && activeElement.className.includes('Embers-focusVisible')) && focusedRowIndex !== -1) {
        setFocusedRowIndex(-1);
      }
    };
    var handleKeydown = function handleKeydown(e) {
      if (e.key === 'Tab') {
        var activeElement = document.activeElement;
        if (!(activeElement !== null && activeElement !== void 0 && activeElement.className.includes(EMBERS_TABLE_CELL_CLASS)) || !(activeElement !== null && activeElement !== void 0 && activeElement.className.includes(EMBERS_CHECKBOX_CLASS))) {
          setFocusedRowIndex(-1);
        }
      }
    };
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
    return function () {
      document.removeEventListener('click', handleClick);
      document.addEventListener('keydown', handleKeydown);
    };
  }, [focusedRowIndex]);
  var isSelected = function isSelected(row) {
    return selected ? selected.some(function (item) {
      return item[identifier] === row[identifier];
    }) : false;
  };
  var handleClick = function handleClick(event, row) {
    event.stopPropagation();
    if (!selected || !setSelected) return;
    if (typeof row[identifier] !== 'string') return;
    var selectedIndex = selected.map(function (item) {
      return item[identifier];
    }).indexOf(row[identifier]);
    var newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected && setSelected(newSelected);

    // should clear the focus style of row
    if (focusedRowIndex !== -1) {
      setFocusedRowIndex(-1);
    }
  };
  var sortedData = !isDataSorted && order && orderBy ? _toConsumableArray(rows).sort(order === 'desc' ? function (a, b) {
    return descendingComparator(a, b, orderBy);
  } : function (a, b) {
    return -descendingComparator(a, b, orderBy);
  }) : _toConsumableArray(rows);
  var mappedData = dataMapping ? sortedData.map(dataMapping) : void 0;
  var renderMappedData = function renderMappedData(item, index, row) {
    return mappedData && mappedKeys && mappedKeys !== null && mappedKeys !== void 0 && mappedKeys.includes(item.id) ? mappedData[index][item.id] : row[item.id];
  };
  var onRowKeyUp = function onRowKeyUp(row, rowIndex) {
    return function (e) {
      var activeElement = document.activeElement;
      switch (e.key) {
        case 'Tab':
          if (activeElement !== null && activeElement !== void 0 && activeElement.className.includes(EMBERS_TABLE_CELL_CLASS)) {
            setFocusedRowIndex(rowIndex);
          } else {
            setFocusedRowIndex(-1);
          }
          break;
        case 'Enter':
          if (focusedRowIndex !== -1) {
            onRowClick === null || onRowClick === void 0 || onRowClick(row);
          }
          break;
      }
    };
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: embersTableBodyTheme
  }, /*#__PURE__*/React.createElement(TableBody, null, sortedData.map(function (row, rowIndex) {
    var isItemSelected = isSelected(row);
    var labelId = "EmbersTableBody-CheckboxColumn-".concat(rowIndex);
    var checkboxDisabled = getRowCheckboxDisabled === null || getRowCheckboxDisabled === void 0 ? void 0 : getRowCheckboxDisabled(row);
    var rowDisabled = getRowDisabled === null || getRowDisabled === void 0 ? void 0 : getRowDisabled(row);
    var onEnterTooltip = function onEnterTooltip() {
      setTooltipHoverRowIndex(rowIndex);
    };
    var onLeaveTooltip = function onLeaveTooltip() {
      setTooltipHoverRowIndex(-1);
    };
    var extraRowClasses = '';
    if (getExtraRowClasses) {
      extraRowClasses = getExtraRowClasses(row);
    }
    return /*#__PURE__*/React.createElement(TableRow, {
      hover: onRowClick ? true : false,
      tabIndex: -1,
      key: "".concat(row[identifier], "-").concat(rowIndex),
      selected: isItemSelected,
      className: classnames(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        'EmbersTable-row-clickable': onRowClick
      }, "".concat(rowDisabledClassName), rowDisabledClassName && rowDisabled), 'EmbersTable-row-disabled', rowDisabledClassName && rowDisabled), 'EmbersTable-row-tooltip-hover', tooltipHoverRowIndex === rowIndex), 'Embers-focusVisible', focusedRowIndex === rowIndex), extraRowClasses),
      onClick: function onClick() {
        onRowClick === null || onRowClick === void 0 || onRowClick(row);
      },
      onKeyUp: onRowKeyUp(row, rowIndex)
    }, selected && setSelected && /*#__PURE__*/React.createElement(EmbersTableCell, {
      padding: "checkbox",
      className: "fixed-checkbox",
      shouldShowTooltip: function shouldShowTooltip() {
        return false;
      }
    }, /*#__PURE__*/React.createElement(EmbersCheckbox, {
      color: "primary",
      checked: isItemSelected,
      inputProps: bodyCheckboxesLabels ? {
        'aria-label': isItemSelected ? bodyCheckboxesLabels.checkedLabel : bodyCheckboxesLabels.uncheckedLabel
      } : undefined,
      onClick: function onClick(event) {
        return handleClick(event, row);
      },
      disabled: rowDisabled || checkboxDisabled
    })), headCells.map(function (item, cellIndex) {
      var _item$customTooltipCo;
      var cellContent = renderMappedData(item, rowIndex, row);
      var cellTooltipContent = (_item$customTooltipCo = item.customTooltipContent) === null || _item$customTooltipCo === void 0 ? void 0 : _item$customTooltipCo.call(item, row, rowIndex, cellContent);
      var focusable = onRowClick && cellIndex === 0;
      if (rowDisabled) {
        focusable = false;
      }
      if (cellIndex === 0) {
        return /*#__PURE__*/React.createElement(EmbersTableCell, _extends({
          tabIndex: focusable ? 0 : undefined,
          key: item.id,
          component: "td",
          id: labelId,
          scope: "row",
          padding: "none",
          className: item.icon ? 'EmbersTable-BodyCell-icon' : 'EmbersTable-BodyCell-content',
          shouldShowTooltip: item.shouldShowTooltip,
          getTooltipPopperState: item.getTooltipPopperState,
          tooltipContent: cellTooltipContent,
          onEnterTooltip: onEnterTooltip,
          onLeaveTooltip: onLeaveTooltip,
          align: item.align
        }, item.columnProps), cellContent);
      }
      return /*#__PURE__*/React.createElement(EmbersTableCell, _extends({
        key: item.id,
        className: item.icon ? 'EmbersTable-BodyCell-icon' : 'EmbersTable-BodyCell-content',
        shouldShowTooltip: item.shouldShowTooltip,
        getTooltipPopperState: item.getTooltipPopperState,
        tooltipContent: cellTooltipContent,
        onEnterTooltip: onEnterTooltip,
        onLeaveTooltip: onLeaveTooltip,
        align: item.align
      }, item.columnProps), cellContent);
    }), eyeColumn && /*#__PURE__*/React.createElement(EmbersTableCell, {
      key: "eye-column",
      className: "EmbersTableBody-EyeColumn",
      width: 48
    }));
  })));
}